import { render, staticRenderFns } from "./StrategyRiskConfirmModal.vue?vue&type=template&id=52b954a6&scoped=true"
import script from "./StrategyRiskConfirmModal.vue?vue&type=script&lang=js"
export * from "./StrategyRiskConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./StrategyRiskConfirmModal.vue?vue&type=style&index=0&id=52b954a6&prod&scoped=true&lang=css"
import style1 from "./StrategyRiskConfirmModal.vue?vue&type=style&index=1&id=52b954a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b954a6",
  null
  
)

export default component.exports